<template>
  <generic-trash
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :getParams="getParamsAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleId="PayloadMultipleId"
    :BreadcrumbName="BreadcrumbName"
  />
</template>

<script>
import { i18n } from '@/i18n'
import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/GroupsFilter.vue'
import { getGroups } from '@/services/configurations/groups/getGroups'
import { downloadGroupsExcel } from '@/services/configurations/groups/downloadGroupsExcel'
import { deleteTrashGroup } from '@/services/trash/deleteTrashGroup'
import { restoreTrashGroup } from '@/services/trash/restoreTrashGroup'

export default {
  name: 'vista-papelera-grupos',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'groups',
      dialogTitle: i18n.t('groups.delete_group'),
      dialogMesage: i18n.t('app.delete_permanent_selected_confirmation', { entity: i18n.t('groups.header').toLowerCase() }),
      ExcelName: 'empresas-borrados.xlsx',
      idVista: 50,
      HeaderTitle: i18n.t('trash.groups'),
      vuexnamespace: 'trashGroups',
      BreadcrumbName: 'Nombre',
      PayloadSingleId: 'IdGrupo',
      PayloadMultipleId: 'idGrupos'
    }
  },
  methods: {
    getParamsAux (data) {
      return {
        idGrupo: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getGroups(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await downloadGroupsExcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashGroup(payload)
    },
    doDeleteAux: async function (payload) {
      return await deleteTrashGroup(payload)
    },
  }
}
</script>
